export default __webpack_public_path__ + "static/media/copy-machine.f70c57d2.png";